module.exports = "/images/banamex.svg?0522cff3dc443e113599daa7d77708b6";